module.exports = __webpack_public_path__ + "img/people-app.7619a441.svg";